class reveal {
    constructor (theme, elem) {
        this._trigger = elem
        this._container = this.getContainer(elem)
        this._open = false
        this._reveal = this._container.querySelector('[data-reveal-elem]')
    }

    onInit () {
        this._trigger.addEventListener('click', e => {
            let newHeight = this._open ? '0px' : this._reveal.scrollHeight + 'px'
            this._reveal.style.height = newHeight
            this._trigger.classList.toggle('triggered')
            this._reveal.classList.toggle('triggered')
            this._container.classList.toggle('triggered')
            this._open = !this._open
        })
    }

    getContainer (triggerElem) {
        let foundElem = false
        let checkElem = triggerElem
        while (!foundElem) {
            if (checkElem.dataset.revealContainer === '') {
                foundElem = checkElem
            } else {
                checkElem = checkElem.parentElement
            }
        }
        return foundElem
    }
}

export default reveal



// WEBPACK FOOTER //
// ./src/scripts/components/Reveal.js